import React, { useCallback } from 'react';
import { Repeat } from '@crabs-ai/web-icons';
import { ToolButton } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';
import { setLoop } from '../state/actions/loop';
import { saveLoop } from '../state/loop-persistance';
import { useLoop, useWriteContext } from '../utils/use-context';

export const LoopButton: React.FC = () => {
  const t = useTranslations();
  const { setState } = useWriteContext();
  const loop = useLoop();

  const onClickLoop = useCallback(() => {
    setState({
      update: (state) => {
        saveLoop(!state.loop);
        return setLoop(state, !state.loop);
      },
      commitToUndoStack: false,
    });
  }, [setState]);

  return (
    <ToolButton
      size="sm"
      state={loop ? 'selected' : 'default'}
      onClick={onClickLoop}
      isShowTooltip
      tooltipNode={
        loop
          ? t('Editor.timeline-controls.loop-off')
          : t('Editor.timeline-controls.loop-on')
      }
      tooltipPosition="top"
    >
      <Repeat />
    </ToolButton>
  );
};
